import React from 'react';

// The app's standard tick (DiaryV2 nep-checkbox) — white check on charcoal fill.
const CheckTick = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
    <path d="M2.5 6L5 8.5L9.5 3.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// StepPersonalise — buy for yourself or send as a gift (recipient + message +
// From), then choose when it sends (now / scheduled) and how (email / PDF).
// The gift fields feed the live preview's gift frame.
const StepPersonalise = ({ value, onChange }) => {
  const v = value;
  const isGift = v.giftMode === 'gift';
  const today = new Date().toISOString().slice(0, 10);

  return (
    <section className="gcs-step">
      <h2 className="gcs-step-title">Who is it for</h2>

      <div className="gcs-seg">
        <button
          type="button"
          className={`gcs-seg-btn ${!isGift ? 'is-active' : ''}`}
          onClick={() => onChange({ giftMode: 'self' })}
        >
          For myself
        </button>
        <button
          type="button"
          className={`gcs-seg-btn ${isGift ? 'is-active' : ''}`}
          onClick={() => onChange({ giftMode: 'gift' })}
        >
          Send as a gift
        </button>
      </div>

      {isGift && (
        <div className="gcs-fields">
          <label className="gcs-field">
            <span className="gcs-field-label">Recipient name</span>
            <input type="text" value={v.recipientName} placeholder="e.g. Alex"
              onChange={(e) => onChange({ recipientName: e.target.value })} />
          </label>
          <label className="gcs-field">
            <span className="gcs-field-label">Recipient email</span>
            <input type="email" value={v.recipientEmail} placeholder="alex@example.com"
              onChange={(e) => onChange({ recipientEmail: e.target.value })} />
          </label>
          <label className="gcs-field">
            <span className="gcs-field-label">Message <span className="gcs-field-opt">(optional)</span></span>
            <textarea rows={3} maxLength={200} value={v.message} placeholder="Add a personal note"
              onChange={(e) => onChange({ message: e.target.value })} />
          </label>
          <label className="gcs-field">
            <span className="gcs-field-label">From</span>
            <input type="text" value={v.fromName} placeholder="Your name"
              onChange={(e) => onChange({ fromName: e.target.value })} />
          </label>

          <div className="gcs-field">
            <span className="gcs-field-label">When to send</span>
            <div className="gcs-seg gcs-seg-sm">
              <button type="button" className={`gcs-seg-btn ${v.deliverWhen === 'now' ? 'is-active' : ''}`}
                onClick={() => onChange({ deliverWhen: 'now' })}>Send now</button>
              <button type="button" className={`gcs-seg-btn ${v.deliverWhen === 'scheduled' ? 'is-active' : ''}`}
                onClick={() => onChange({ deliverWhen: 'scheduled' })}>Schedule</button>
            </div>
            {v.deliverWhen === 'scheduled' && (
              <input className="gcs-date" type="date" value={v.deliverDate} min={today}
                onChange={(e) => onChange({ deliverDate: e.target.value })} />
            )}
          </div>
        </div>
      )}

      <div className="gcs-field gcs-delivery">
        <span className="gcs-field-label">Delivery</span>
        <label className="gcs-check">
          <input type="checkbox" checked={v.deliverEmail}
            onChange={(e) => onChange({ deliverEmail: e.target.checked })} />
          <span className="gcs-check-box"><CheckTick /></span>
          <span className="gcs-check-label">Email{isGift ? ' to recipient' : ''}</span>
        </label>
        <label className="gcs-check">
          <input type="checkbox" checked={v.deliverPdf}
            onChange={(e) => onChange({ deliverPdf: e.target.checked })} />
          <span className="gcs-check-box"><CheckTick /></span>
          <span className="gcs-check-label">Print at home (PDF)</span>
        </label>
      </div>
    </section>
  );
};

export default StepPersonalise;
